"use strict";
exports.__esModule = true;
exports.GdcKpi = void 0;
var tslib_1 = require("tslib");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
/**
 * @public
 */
var GdcKpi;
(function (GdcKpi) {
    function isKpiContentWithoutComparison(obj) {
        return !isEmpty_1["default"](obj) && obj.comparisonType === "none";
    }
    GdcKpi.isKpiContentWithoutComparison = isKpiContentWithoutComparison;
    function isKpi(obj) {
        return !isEmpty_1["default"](obj) && obj.meta.category === "kpi";
    }
    GdcKpi.isKpi = isKpi;
    function isWrappedKpi(obj) {
        return !isEmpty_1["default"](obj) && !!obj.kpi;
    }
    GdcKpi.isWrappedKpi = isWrappedKpi;
})(GdcKpi = exports.GdcKpi || (exports.GdcKpi = {}));
//# sourceMappingURL=GdcKpi.js.map